// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-sheet.v-card[data-v-e9d9561a]{border-radius:10px}.hasSelectedData[data-v-e9d9561a]{background-color:rgba(238,165,7,.2)}.contact__panel[data-v-e9d9561a]{background-color:#fff;border-radius:10px}.filter-userrole__input[data-v-e9d9561a]{max-width:500px}[data-v-e9d9561a] .switch__active .v-input__slot{margin-bottom:0}[data-v-e9d9561a] .switch__active .v-messages{display:none}", ""]);
// Exports
module.exports = exports;
